"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DRAFT: 'draft',
  VIDEO: 'video'
};
exports.default = _default;